import { Bottomsheet, HeadTitle, Button, Spacer } from 'oui';
import { DefaultBox } from '../../etc/LBox/LBox';
import React, { MouseEventHandler } from 'react';

interface IReuseBottomsheet {
  isOpen: boolean;
  onClose: () => void;
  onClickButton: (e: React.MouseEvent<HTMLElement>) => void;
  onClickSubButton: (e: React.MouseEvent<HTMLElement>) => void;
}

export const ReuseBottomsheet = ({
  isOpen = false,
  onClose,
  onClickButton,
  onClickSubButton,
}: IReuseBottomsheet) => {
  return (
    <>
      <Bottomsheet
        backdrop={true}
        isMaxHeight={false}
        isOpen={isOpen}
        children={
          <>
            <HeadTitle
              textTitle={'다시 만나서 반가워요!'}
              subTitle={
                '이전에 입력하신 정보가 있네요.\n 이어서 입력하시겠어요?'
              }
              buttonIconName={'CloseSharp'}
              onClickButton={onClose}
            />
            <DefaultBox>
              <Button
                flexible={true}
                configuration={'contained'}
                children={'이어서 입력하기'}
                onClick={(e) => onClickButton(e)}
              />
              <Spacer size={'md'} />
              <Button
                flexible={true}
                size={'md'}
                state={'enabled'}
                configuration={'ghost'}
                children={'처음부터 입력하기'}
                onClick={(e) => onClickSubButton(e)}
              />
            </DefaultBox>
          </>
        }
      />
    </>
  );
};
